{
  "id": "hephaestus",
  "pantheon": "greeks",
  "name": {
    "pt-BR": "Hefesto",
    "en": "Hephaestus"
  },
  "icon": "gods/hephaestus",
  "portrait": "gods/hephaestus-portrait",
  "age": "mythic",
  "freeUnitsOnAgeUp": {
    "colossus": 1
  },
  "unlocks": [
    "colossus",
    "hand-of-talos",
    "shoulder-of-talos",
    "olympian-weapons",
    "forge-of-olympus"
  ],
  "powers": ["plenty"],
  "meta": {
    "source": "Game files 19.17020 (techtree.xml)",
    "checkedAt": "2026-10-18",
    "confidence": "high",
    "note": "MythicAgeHephaestus: CreateUnit Colossus at a Temple (one free myth unit), god power PlentyVault (cooldown 180 s); enables the listed unit and techs."
  }
}
